module.exports = __webpack_public_path__ + "img/hand_of_midas.1a75afa6.png";